"use client";

import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export const CommentInput = ({
  onSend,
  onCancel,
  initialContent = "",
  theme,
}: {
  onSend: (content: string) => void;
  onCancel?: () => void;
  initialContent?: string;
  theme?: string;
}) => {
  const [content, setContent] = useState(initialContent);
  function onChange(textarea: HTMLTextAreaElement) {
    setContent(textarea.value);
  }

  useEffect(() => {
    setContent(initialContent);
  }, [initialContent]);

  return (
    <div className={"mb-8"}>
      <Textarea
        onChange={(e) => onChange(e.target as HTMLTextAreaElement)}
        className={"mb-4 h-12"}
        placeholder="Dodaj komentarz..."
        value={content}
      />
      <div className={"flex items-center justify-start gap-4"}>
        {theme === "edit" ? (
          <div
            className={"flex h-full items-center justify-center select-none"}
          >
            <Button
              variant={"blue"}
              onClick={() => {
                onSend(content);
                setContent("");
              }}
            >
              Zapisz
            </Button>
            <Button variant={"outline"} onClick={onCancel}>
              Anuluj
            </Button>
          </div>
        ) : content.length > 0 ? (
          <Button
            variant={"blue"}
            onClick={() => {
              onSend(content);
              setContent("");
            }}
          >
            Zapisz
          </Button>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
